import styled, { css } from 'styled-components'

export const ResizeHandle = styled.div(
  ({ theme }) => css`
    position: absolute;
    right: -10px;
    top: 0;
    bottom: 0;

    /* The ResizeHandle is only 2px wide visually, so we make an invisible
     * area of 10px this way its easier to grab it and drag
     */
    width: 10px;

    opacity: 0;

    &:hover {
      opacity: 1;
    }

    &:active {
      &::before {
        background-color: ${theme.colors.background.tertiary.A};
      }
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      /* This is the visible width part of the ResizeHandle */
      width: 2px;
      height: 100%;
      background-color: ${theme.colors.background.tertiary.B};
    }

    /* This will avoid a flickering effect when resizing */
    transition-timing-function: ease-in-out;
    transition-duration: 0.3s;
    transition-property: transform, opacity;
    will-change: transform;
  `
)
